import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Router, RouterProvider, Routes } from 'react-router';
import Reg from './Pages/Reg/Reg';
import './assets/fonts/museosans/stylesheet.css'
import Header from './Components/semantics/Header/Header';
import Footer from './Components/semantics/Header/Footer/Footer';
import { Soglasie } from './Pages/Soglasie/Soglasie';
import Auth from './Pages/Auth/Auth';
import { Provider, useDispatch, useSelector } from 'react-redux';
import { RootState, store } from './Store/store';
import { init } from './Store/userSlice';
import User from './Pages/User/User';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);


root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App/>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
